export const environment = {
  apiUrl: 'https://dev-api.licensecomply.com',
  production: false,
};
